import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Clipboard from 'clipboard';

import { getUserContext } from '../../../actions/UserActions';
import { fetchPages } from '../../../actions/website/PageActions';

import '../../../stylesheets/pages/PublishWebsiteModal.less';

import SparkleLeft from '../../../assets/images/registry/Registry_Sparkle_Left.svg';
import SparkleRight from '../../../assets/images/registry/Registry_Sparkle_Right.svg';
import KitchenTabletop from '../../../assets/images/registry/Registry_Kitchen_Tabletop@2x.jpg';
import Exchange from '../../../assets/images/registry/Registry_Exchange@2x.jpg';
import Arrow from '../../../assets/images/registry/Never_Lug_Arrow.svg';
import MoreGifts from '../../../assets/images/registry/Registry_More_Gifts@2x.jpg';

class PublishRegistryModalv3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported(),
      clipboardErrorMessage: undefined
    };
  }

  componentDidMount() {
    this.props.handleGetUserContext()
      .then(() => {
        const { userContext } = this.props;
        if (userContext.has_wedding_account) {
          this.props.onFetchPages();
        }
      });
    this.initializeClipboard();
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#publish-registry-share-modal-url-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      const currentButtonText = target.innerText;
      target.innerText = 'Copied!';
      target.disabled = true;
      target.style.color = '#505050';
      setTimeout(() => {
        target.innerText = currentButtonText;
        target.disabled = false;
        target.style.color = '#01b4c0';
      }, 1500);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  render() {
    const { userContext } = this.props;
    const { isClipboardSupported } = this.state;
    const slug = userContext.user_role_account_weddings && userContext.user_role_account_weddings[0].slug;
    return (
      <div id="registry-publish-modalv3">
        <div className="containter-fluid">
          <div className="go-live-header">
            <img src={SparkleLeft} className="go-live-left-sparkle " height="35" alt="" />
            <h4 className="go-live-title">You&rsquo;re live! Guests can now <br /> see and shop your registry.</h4>
            <img src={SparkleRight} className="go-live-right-sparkle" height="18" alt="" />
            <div>
              {isClipboardSupported &&
                <a to="">
                  <button id="publish-registry-share-modal-url-copy" className="" data-clipboard-text={`${window.location.protocol}//${window.location.host}/registry/${slug}`}>
                      Copy Link
                  </button>
                </a>
              }
              <span className="divider"> | </span>
              <Link href={`/registry/${slug}?preview=true`}>View Registry</Link>
            </div>
          </div>
          <div className="go-live-body container-fluid">
            <h2 className="title">{"What's"} next?</h2>
            <div className="go-live-section-container row">
              <img className="col-md-3 col-sm-3 col-xs-4" src={KitchenTabletop} alt="" />
              <h4 className="col-md-5  col-sm-5 col-xs-8">Tabletop and Kitchen Will Fly Off Your Registry</h4>
              <div className="col-md-5  col-sm-5 col-xs-12">
                <p>Guests love gifting these categories. <br /> So make sure your registry has plenty.</p>
                <div>
                  <Link href="/shop/category/dining">Explore Tabletop</Link>
                  <span className="divider">  | </span>
                  <Link href="/shop/category/kitchen">Explore Kitchen</Link>
                </div>
              </div>
            </div>
            <div className="go-live-section-container row">
              <img className="col-md-3 col-sm-3 col-xs-4" src={Exchange} alt="" />
              <div className="col-md-4 col-sm-4 col-xs-8 exchange-section">
                <h4>Exchange Gifts Anytime— It&apos;s Easy!</h4>
                <p className="hidden-xs">You can even do it before they ship. {"We'll"} never tell your guests, but {"we'll"} note all original gifts, so you can thank them.</p>
              </div>
              <p className="hidden-md hidden-sm hidden-lg col-xs-12">You can even do it before they ship. {"We'll"} never tell your guests, but {"we'll"} note all original gifts, so you can thank them.</p>
              <img className="publish-registry-modal-v3__copy-img hidden-xs" src={Arrow} alt="" height="100" />
            </div>
            <div className="go-live-section-container row">
              <img className="col-md-3 col-sm-3 col-xs-4" src={MoreGifts} alt="" />
              <h4 className="col-md-5 col-sm-5 col-xs-8">You&apos;ll Likely Rake Up Some Zola Store Credit</h4>
              <p className="col-md-5 col-sm-5 col-xs-12">Exchanged or returned gifts turn into credit you can use on anything in our store—furniture, a swanky TV... the {"sky's"} the limit!</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PublishRegistryModalv3.propTypes = {
  handleGetUserContext: PropTypes.func,
  userContext: PropTypes.shape({}),
  onFetchPages: PropTypes.func,
};

const mapStateToProps = state => ({
  userContext: state.user.userContext,
  pages: state.website && state.website.pages
});

const mapDispatchToProps = dispatch => ({
  handleGetUserContext: () => dispatch(getUserContext()),
  onFetchPages: () => dispatch(fetchPages())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishRegistryModalv3);



// WEBPACK FOOTER //
// ./src/components/manage/website/PublishRegistryModalv3.jsx